<template>
  <!-- 竞赛管理 结果显示 -->
    <div class="board">
        <el-form :model="form" ref="form" label-width="200px">
            <el-row>
                <el-col :span="14">
                    <el-form-item :label="formTextConfig.displayScoreLabel" prop="displayScoreLabel" style="margin-top:30px">
                        <el-select v-model="form.isDisplayScore" style="width: 250px">
                            <el-option v-for="item in displayOptions" :key="item.dict_value" :label="item.dict_label"
                                       :value="item.dict_value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.displayAnswerLabel" prop="displayAnswerLabel" style="margin-top:30px">
                        <el-select v-model="form.isDisplayAnswer" style="width: 250px">
                            <el-option v-for="item in displayOptions" :key="item.dict_value" :label="item.dict_label"
                                       :value="item.dict_value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <p class="info" style="width: 250px">{{formTextConfig.displayTip}}</p>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button type="primary" @click="submit">{{ buttonTextConfig.ok }}</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>

import {updateExam} from "@/api/arrangement";

export default {
    props: ['examId', 'examStatus'],
    data() {
        return {
            form: {
                isDisplayScore: '0',
                isDisplayAnswer: '0',
            },
            displayOptions: [],
        }
    },
    computed: {
        resultTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit.result
        },
        formTextConfig() {
            return this.resultTextConfig.form
        },
        buttonTextConfig() {
            return this.resultTextConfig.button
        },
    },
    methods: {
        submit() {
            if (this.examId) {
                this.$store.dispatch("setExamDisplaySetting", {
                    id: this.examId,
                    data: {
                        isDisplayScore: Boolean(parseInt(this.form.isDisplayScore)),
                        isDisplayAnswer: Boolean(parseInt(this.form.isDisplayAnswer)),
                    }
                }).then(res => {
                    if (res.status === 200) {
                        this.$message.success("操作成功")
                    }
                })
            }
        }
    },
    created() {
        this.$store.dispatch("getDict", 'exam_answer_display').then(res => {
            this.displayOptions = res.data
        });

        if (this.examId) {
            this.$store.dispatch("getExamDisplaySetting", this.examId).then(res => {
                this.form.isDisplayScore = res.data.isDisplayScore ? '1' : '0';
                this.form.isDisplayAnswer = res.data.isDisplayAnswer ? '1' : '0';
            });
        }
    },
}
</script>

<style scoped>
</style>
